const AVAILABLE_TIMEZONES = [
  {
    key: 'International Date Line West',
    name: '(GMT-11:00) International Date Line West',
    offset: -660,
    iana: 'Etc/GMT+12',
  },
  {
    key: 'Midway Island',
    name: '(GMT-11:00) Midway Island',
    offset: -660,
    iana: 'Pacific/Midway',
  },
  {
    key: 'American Samoa',
    name: '(GMT-11:00) American Samoa',
    offset: -660,
    iana: 'Pacific/Pago_Pago',
  },
  {
    key: 'Hawaii',
    name: '(GMT-10:00) Hawaii',
    offset: -600,
    iana: 'Pacific/Honolulu',
  },
  {
    key: 'Alaska',
    name: '(GMT-09:00) Alaska',
    offset: -540,
    iana: 'America/Juneau',
  },
  {
    key: 'Pacific Time (US & Canada)',
    name: '(GMT-08:00) Pacific Time (US & Canada)',
    offset: -480,
    iana: 'America/Los_Angeles',
  },
  {
    key: 'Tijuana',
    name: '(GMT-08:00) Tijuana',
    offset: -480,
    iana: 'America/Tijuana',
  },
  {
    key: 'Mountain Time (US & Canada)',
    name: '(GMT-07:00) Mountain Time (US & Canada)',
    offset: -420,
    iana: 'America/Denver',
  },
  {
    key: 'Arizona',
    name: '(GMT-07:00) Arizona',
    offset: -420,
    iana: 'America/Phoenix',
  },
  {
    key: 'Chihuahua',
    name: '(GMT-07:00) Chihuahua',
    offset: -420,
    iana: 'America/Chihuahua',
  },
  {
    key: 'Mazatlan',
    name: '(GMT-07:00) Mazatlan',
    offset: -420,
    iana: 'America/Mazatlan',
  },
  {
    key: 'Central Time (US & Canada)',
    name: '(GMT-06:00) Central Time (US & Canada)',
    offset: -360,
    iana: 'America/Chicago',
  },
  {
    key: 'Saskatchewan',
    name: '(GMT-06:00) Saskatchewan',
    offset: -360,
    iana: 'America/Regina',
  },
  {
    key: 'Guadalajara',
    name: '(GMT-06:00) Guadalajara',
    offset: -360,
    iana: 'America/Mexico_City',
  },
  {
    key: 'Mexico City',
    name: '(GMT-06:00) Mexico City',
    offset: -360,
    iana: 'America/Mexico_City',
  },
  {
    key: 'Monterrey',
    name: '(GMT-06:00) Monterrey',
    offset: -360,
    iana: 'America/Monterrey',
  },
  {
    key: 'Central America',
    name: '(GMT-06:00) Central America',
    offset: -360,
    iana: 'America/Guatemala',
  },
  {
    key: 'Eastern Time (US & Canada)',
    name: '(GMT-05:00) Eastern Time (US & Canada)',
    offset: -300,
    iana: 'America/New_York',
  },
  {
    key: 'Indiana (East)',
    name: '(GMT-05:00) Indiana (East)',
    offset: -300,
    iana: 'America/Indiana/Indianapolis',
  },
  {
    key: 'Bogota',
    name: '(GMT-05:00) Bogota',
    offset: -300,
    iana: 'America/Bogota',
  },
  { key: 'Lima', name: '(GMT-05:00) Lima', offset: -300, iana: 'America/Lima' },
  {
    key: 'Quito',
    name: '(GMT-05:00) Quito',
    offset: -300,
    iana: 'America/Lima',
  },
  {
    key: 'Atlantic Time (Canada)',
    name: '(GMT-04:00) Atlantic Time (Canada)',
    offset: -240,
    iana: 'America/Halifax',
  },
  {
    key: 'Caracas',
    name: '(GMT-04:30) Caracas',
    offset: -270,
    iana: 'America/Caracas',
  },
  {
    key: 'La Paz',
    name: '(GMT-04:00) La Paz',
    offset: -240,
    iana: 'America/La_Paz',
  },
  {
    key: 'Santiago',
    name: '(GMT-04:00) Santiago',
    offset: -240,
    iana: 'America/Santiago',
  },
  {
    key: 'Newfoundland',
    name: '(GMT-03:30) Newfoundland',
    offset: -210,
    iana: 'America/St_Johns',
  },
  {
    key: 'Brasilia',
    name: '(GMT-03:00) Brasilia',
    offset: -180,
    iana: 'America/Sao_Paulo',
  },
  {
    key: 'Buenos Aires',
    name: '(GMT-03:00) Buenos Aires',
    offset: -180,
    iana: 'America/Argentina/Buenos_Aires',
  },
  {
    key: 'Montevideo',
    name: '(GMT-03:00) Montevideo',
    offset: -180,
    iana: 'America/Montevideo',
  },
  {
    key: 'Georgetown',
    name: '(GMT-04:00) Georgetown',
    offset: -240,
    iana: 'America/Guyana',
  },
  {
    key: 'Greenland',
    name: '(GMT-03:00) Greenland',
    offset: -180,
    iana: 'America/Nuuk',
  },
  {
    key: 'Mid-Atlantic',
    name: '(GMT-02:00) Mid-Atlantic',
    offset: -120,
    iana: 'Atlantic/South_Georgia',
  },
  {
    key: 'Azores',
    name: '(GMT-01:00) Azores',
    offset: -60,
    iana: 'Atlantic/Azores',
  },
  {
    key: 'Cape Verde Is.',
    name: '(GMT-01:00) Cape Verde Is.',
    offset: -60,
    iana: 'Atlantic/Cape_Verde',
  },
  {
    key: 'Dublin',
    name: '(GMT+00:00) Dublin',
    offset: 0,
    iana: 'Europe/Dublin',
  },
  {
    key: 'Edinburgh',
    name: '(GMT+00:00) Edinburgh',
    offset: 0,
    iana: 'Europe/London',
  },
  {
    key: 'Lisbon',
    name: '(GMT+00:00) Lisbon',
    offset: 0,
    iana: 'Europe/Lisbon',
  },
  {
    key: 'London',
    name: '(GMT+00:00) London',
    offset: 0,
    iana: 'Europe/London',
  },
  {
    key: 'Casablanca',
    name: '(GMT+00:00) Casablanca',
    offset: 0,
    iana: 'Africa/Casablanca',
  },
  {
    key: 'Monrovia',
    name: '(GMT+00:00) Monrovia',
    offset: 0,
    iana: 'Africa/Monrovia',
  },
  { key: 'UTC', name: '(GMT+00:00) UTC', offset: 0, iana: 'Etc/UTC' },
  {
    key: 'Belgrade',
    name: '(GMT+01:00) Belgrade',
    offset: 60,
    iana: 'Europe/Belgrade',
  },
  {
    key: 'Bratislava',
    name: '(GMT+01:00) Bratislava',
    offset: 60,
    iana: 'Europe/Bratislava',
  },
  {
    key: 'Budapest',
    name: '(GMT+01:00) Budapest',
    offset: 60,
    iana: 'Europe/Budapest',
  },
  {
    key: 'Ljubljana',
    name: '(GMT+01:00) Ljubljana',
    offset: 60,
    iana: 'Europe/Ljubljana',
  },
  {
    key: 'Prague',
    name: '(GMT+01:00) Prague',
    offset: 60,
    iana: 'Europe/Prague',
  },
  {
    key: 'Sarajevo',
    name: '(GMT+01:00) Sarajevo',
    offset: 60,
    iana: 'Europe/Sarajevo',
  },
  {
    key: 'Skopje',
    name: '(GMT+01:00) Skopje',
    offset: 60,
    iana: 'Europe/Skopje',
  },
  {
    key: 'Warsaw',
    name: '(GMT+01:00) Warsaw',
    offset: 60,
    iana: 'Europe/Warsaw',
  },
  {
    key: 'Zagreb',
    name: '(GMT+01:00) Zagreb',
    offset: 60,
    iana: 'Europe/Zagreb',
  },
  {
    key: 'Brussels',
    name: '(GMT+01:00) Brussels',
    offset: 60,
    iana: 'Europe/Brussels',
  },
  {
    key: 'Copenhagen',
    name: '(GMT+01:00) Copenhagen',
    offset: 60,
    iana: 'Europe/Copenhagen',
  },
  {
    key: 'Madrid',
    name: '(GMT+01:00) Madrid',
    offset: 60,
    iana: 'Europe/Madrid',
  },
  { key: 'Paris', name: '(GMT+01:00) Paris', offset: 60, iana: 'Europe/Paris' },
  {
    key: 'Amsterdam',
    name: '(GMT+01:00) Amsterdam',
    offset: 60,
    iana: 'Europe/Amsterdam',
  },
  {
    key: 'Berlin',
    name: '(GMT+01:00) Berlin',
    offset: 60,
    iana: 'Europe/Berlin',
  },
  { key: 'Bern', name: '(GMT+01:00) Bern', offset: 60, iana: 'Europe/Zurich' },
  { key: 'Rome', name: '(GMT+01:00) Rome', offset: 60, iana: 'Europe/Rome' },
  {
    key: 'Stockholm',
    name: '(GMT+01:00) Stockholm',
    offset: 60,
    iana: 'Europe/Stockholm',
  },
  {
    key: 'Vienna',
    name: '(GMT+01:00) Vienna',
    offset: 60,
    iana: 'Europe/Vienna',
  },
  {
    key: 'West Central Africa',
    name: '(GMT+01:00) West Central Africa',
    offset: 60,
    iana: 'Africa/Algiers',
  },
  {
    key: 'Bucharest',
    name: '(GMT+02:00) Bucharest',
    offset: 120,
    iana: 'Europe/Bucharest',
  },
  {
    key: 'Cairo',
    name: '(GMT+02:00) Cairo',
    offset: 120,
    iana: 'Africa/Cairo',
  },
  {
    key: 'Helsinki',
    name: '(GMT+02:00) Helsinki',
    offset: 120,
    iana: 'Europe/Helsinki',
  },
  { key: 'Kyiv', name: '(GMT+02:00) Kyiv', offset: 120, iana: 'Europe/Kyiv' },
  { key: 'Riga', name: '(GMT+02:00) Riga', offset: 120, iana: 'Europe/Riga' },
  {
    key: 'Sofia',
    name: '(GMT+02:00) Sofia',
    offset: 120,
    iana: 'Europe/Sofia',
  },
  {
    key: 'Tallinn',
    name: '(GMT+02:00) Tallinn',
    offset: 120,
    iana: 'Europe/Tallinn',
  },
  {
    key: 'Vilnius',
    name: '(GMT+02:00) Vilnius',
    offset: 120,
    iana: 'Europe/Vilnius',
  },
  {
    key: 'Athens',
    name: '(GMT+02:00) Athens',
    offset: 120,
    iana: 'Europe/Athens',
  },
  {
    key: 'Istanbul',
    name: '(GMT+02:00) Istanbul',
    offset: 120,
    iana: 'Europe/Istanbul',
  },
  {
    key: 'Minsk',
    name: '(GMT+03:00) Minsk',
    offset: 180,
    iana: 'Europe/Minsk',
  },
  {
    key: 'Jerusalem',
    name: '(GMT+02:00) Jerusalem',
    offset: 120,
    iana: 'Asia/Jerusalem',
  },
  {
    key: 'Harare',
    name: '(GMT+02:00) Harare',
    offset: 120,
    iana: 'Africa/Harare',
  },
  {
    key: 'Pretoria',
    name: '(GMT+02:00) Pretoria',
    offset: 120,
    iana: 'Africa/Johannesburg',
  },
  {
    key: 'Moscow',
    name: '(GMT+04:00) Moscow',
    offset: 240,
    iana: 'Europe/Moscow',
  },
  {
    key: 'St. Petersburg',
    name: '(GMT+04:00) St. Petersburg',
    offset: 240,
    iana: 'Europe/Moscow',
  },
  {
    key: 'Volgograd',
    name: '(GMT+04:00) Volgograd',
    offset: 240,
    iana: 'Europe/Volgograd',
  },
  {
    key: 'Kuwait',
    name: '(GMT+03:00) Kuwait',
    offset: 180,
    iana: 'Asia/Kuwait',
  },
  {
    key: 'Riyadh',
    name: '(GMT+03:00) Riyadh',
    offset: 180,
    iana: 'Asia/Riyadh',
  },
  {
    key: 'Nairobi',
    name: '(GMT+03:00) Nairobi',
    offset: 180,
    iana: 'Africa/Nairobi',
  },
  {
    key: 'Baghdad',
    name: '(GMT+03:00) Baghdad',
    offset: 180,
    iana: 'Asia/Baghdad',
  },
  {
    key: 'Tehran',
    name: '(GMT+03:30) Tehran',
    offset: 210,
    iana: 'Asia/Tehran',
  },
  {
    key: 'Abu Dhabi',
    name: '(GMT+04:00) Abu Dhabi',
    offset: 240,
    iana: 'Asia/Muscat',
  },
  {
    key: 'Muscat',
    name: '(GMT+04:00) Muscat',
    offset: 240,
    iana: 'Asia/Muscat',
  },
  { key: 'Baku', name: '(GMT+04:00) Baku', offset: 240, iana: 'Asia/Baku' },
  {
    key: 'Tbilisi',
    name: '(GMT+04:00) Tbilisi',
    offset: 240,
    iana: 'Asia/Tbilisi',
  },
  {
    key: 'Yerevan',
    name: '(GMT+04:00) Yerevan',
    offset: 240,
    iana: 'Asia/Yerevan',
  },
  { key: 'Kabul', name: '(GMT+04:30) Kabul', offset: 270, iana: 'Asia/Kabul' },
  {
    key: 'Ekaterinburg',
    name: '(GMT+06:00) Ekaterinburg',
    offset: 360,
    iana: 'Asia/Yekaterinburg',
  },
  {
    key: 'Islamabad',
    name: '(GMT+05:00) Islamabad',
    offset: 300,
    iana: 'Asia/Karachi',
  },
  {
    key: 'Karachi',
    name: '(GMT+05:00) Karachi',
    offset: 300,
    iana: 'Asia/Karachi',
  },
  {
    key: 'Tashkent',
    name: '(GMT+05:00) Tashkent',
    offset: 300,
    iana: 'Asia/Tashkent',
  },
  {
    key: 'Chennai',
    name: '(GMT+05:30) Chennai',
    offset: 330,
    iana: 'Asia/Kolkata',
  },
  {
    key: 'Kolkata',
    name: '(GMT+05:30) Kolkata',
    offset: 330,
    iana: 'Asia/Kolkata',
  },
  {
    key: 'Mumbai',
    name: '(GMT+05:30) Mumbai',
    offset: 330,
    iana: 'Asia/Kolkata',
  },
  {
    key: 'New Delhi',
    name: '(GMT+05:30) New Delhi',
    offset: 330,
    iana: 'Asia/Kolkata',
  },
  {
    key: 'Kathmandu',
    name: '(GMT+05:45) Kathmandu',
    offset: 345,
    iana: 'Asia/Kathmandu',
  },
  {
    key: 'Astana',
    name: '(GMT+06:00) Astana',
    offset: 360,
    iana: 'Asia/Almaty',
  },
  { key: 'Dhaka', name: '(GMT+06:00) Dhaka', offset: 360, iana: 'Asia/Dhaka' },
  {
    key: 'Sri Jayawardenepura',
    name: '(GMT+05:30) Sri Jayawardenepura',
    offset: 330,
    iana: 'Asia/Colombo',
  },
  {
    key: 'Almaty',
    name: '(GMT+06:00) Almaty',
    offset: 360,
    iana: 'Asia/Almaty',
  },
  {
    key: 'Novosibirsk',
    name: '(GMT+07:00) Novosibirsk',
    offset: 420,
    iana: 'Asia/Novosibirsk',
  },
  {
    key: 'Rangoon',
    name: '(GMT+06:30) Rangoon',
    offset: 390,
    iana: 'Asia/Yangon',
  },
  {
    key: 'Bangkok',
    name: '(GMT+07:00) Bangkok',
    offset: 420,
    iana: 'Asia/Bangkok',
  },
  {
    key: 'Hanoi',
    name: '(GMT+07:00) Hanoi',
    offset: 420,
    iana: 'Asia/Bangkok',
  },
  {
    key: 'Jakarta',
    name: '(GMT+07:00) Jakarta',
    offset: 420,
    iana: 'Asia/Jakarta',
  },
  {
    key: 'Krasnoyarsk',
    name: '(GMT+08:00) Krasnoyarsk',
    offset: 480,
    iana: 'Asia/Krasnoyarsk',
  },
  {
    key: 'Beijing',
    name: '(GMT+08:00) Beijing',
    offset: 480,
    iana: 'Asia/Shanghai',
  },
  {
    key: 'Chongqing',
    name: '(GMT+08:00) Chongqing',
    offset: 480,
    iana: 'Asia/Chongqing',
  },
  {
    key: 'Hong Kong',
    name: '(GMT+08:00) Hong Kong',
    offset: 480,
    iana: 'Asia/Hong_Kong',
  },
  {
    key: 'Urumqi',
    name: '(GMT+08:00) Urumqi',
    offset: 480,
    iana: 'Asia/Urumqi',
  },
  {
    key: 'Kuala Lumpur',
    name: '(GMT+08:00) Kuala Lumpur',
    offset: 480,
    iana: 'Asia/Kuala_Lumpur',
  },
  {
    key: 'Singapore',
    name: '(GMT+08:00) Singapore',
    offset: 480,
    iana: 'Asia/Singapore',
  },
  {
    key: 'Taipei',
    name: '(GMT+08:00) Taipei',
    offset: 480,
    iana: 'Asia/Taipei',
  },
  {
    key: 'Perth',
    name: '(GMT+08:00) Perth',
    offset: 480,
    iana: 'Australia/Perth',
  },
  {
    key: 'Irkutsk',
    name: '(GMT+09:00) Irkutsk',
    offset: 540,
    iana: 'Asia/Irkutsk',
  },
  {
    key: 'Ulaanbaatar',
    name: '(GMT+08:00) Ulaanbaatar',
    offset: 480,
    iana: 'Asia/Ulaanbaatar',
  },
  { key: 'Seoul', name: '(GMT+09:00) Seoul', offset: 540, iana: 'Asia/Seoul' },
  { key: 'Osaka', name: '(GMT+09:00) Osaka', offset: 540, iana: 'Asia/Tokyo' },
  {
    key: 'Sapporo',
    name: '(GMT+09:00) Sapporo',
    offset: 540,
    iana: 'Asia/Tokyo',
  },
  { key: 'Tokyo', name: '(GMT+09:00) Tokyo', offset: 540, iana: 'Asia/Tokyo' },
  {
    key: 'Yakutsk',
    name: '(GMT+10:00) Yakutsk',
    offset: 600,
    iana: 'Asia/Yakutsk',
  },
  {
    key: 'Darwin',
    name: '(GMT+09:30) Darwin',
    offset: 570,
    iana: 'Australia/Darwin',
  },
  {
    key: 'Adelaide',
    name: '(GMT+09:30) Adelaide',
    offset: 570,
    iana: 'Australia/Adelaide',
  },
  {
    key: 'Canberra',
    name: '(GMT+10:00) Canberra',
    offset: 600,
    iana: 'Australia/Canberra',
  },
  {
    key: 'Melbourne',
    name: '(GMT+10:00) Melbourne',
    offset: 600,
    iana: 'Australia/Melbourne',
  },
  {
    key: 'Sydney',
    name: '(GMT+10:00) Sydney',
    offset: 600,
    iana: 'Australia/Sydney',
  },
  {
    key: 'Brisbane',
    name: '(GMT+10:00) Brisbane',
    offset: 600,
    iana: 'Australia/Brisbane',
  },
  {
    key: 'Hobart',
    name: '(GMT+10:00) Hobart',
    offset: 600,
    iana: 'Australia/Hobart',
  },
  {
    key: 'Vladivostok',
    name: '(GMT+11:00) Vladivostok',
    offset: 660,
    iana: 'Asia/Vladivostok',
  },
  { key: 'Guam', name: '(GMT+10:00) Guam', offset: 600, iana: 'Pacific/Guam' },
  {
    key: 'Port Moresby',
    name: '(GMT+10:00) Port Moresby',
    offset: 600,
    iana: 'Pacific/Port_Moresby',
  },
  {
    key: 'Magadan',
    name: '(GMT+12:00) Magadan',
    offset: 720,
    iana: 'Asia/Magadan',
  },
  {
    key: 'Solomon Is.',
    name: '(GMT+11:00) Solomon Is.',
    offset: 660,
    iana: 'Pacific/Guadalcanal',
  },
  {
    key: 'New Caledonia',
    name: '(GMT+11:00) New Caledonia',
    offset: 660,
    iana: 'Pacific/Noumea',
  },
  { key: 'Fiji', name: '(GMT+12:00) Fiji', offset: 720, iana: 'Pacific/Fiji' },
  {
    key: 'Kamchatka',
    name: '(GMT+12:00) Kamchatka',
    offset: 720,
    iana: 'Asia/Kamchatka',
  },
  {
    key: 'Marshall Is.',
    name: '(GMT+12:00) Marshall Is.',
    offset: 720,
    iana: 'Pacific/Majuro',
  },
  {
    key: 'Auckland',
    name: '(GMT+12:00) Auckland',
    offset: 720,
    iana: 'Pacific/Auckland',
  },
  {
    key: 'Wellington',
    name: '(GMT+12:00) Wellington',
    offset: 720,
    iana: 'Pacific/Auckland',
  },
  {
    key: "Nuku'alofa",
    name: "(GMT+13:00) Nuku'alofa",
    offset: 780,
    iana: 'Pacific/Tongatapu',
  },
  {
    key: 'Tokelau Is.',
    name: '(GMT+13:00) Tokelau Is.',
    offset: 780,
    iana: 'Pacific/Fakaofo',
  },
  {
    key: 'Chatham Is.',
    name: '(GMT+12:45) Chatham Is.',
    offset: 765,
    iana: 'Pacific/Chatham',
  },
  {
    key: 'Samoa',
    name: '(GMT+13:00) Samoa',
    offset: 780,
    iana: 'Pacific/Apia',
  },
];

export default AVAILABLE_TIMEZONES;
